import React from 'react';
import { Skeleton as SkeletonMui } from '@mui/material';
;
function Skeleton(_ref) {
  var variant = _ref.variant;
  return React.createElement(SkeletonMui, {
    variant: variant,
    animation: "wave",
    width: "100%",
    height: "100%"
  });
}
;
export default Skeleton;